import { render, staticRenderFns } from "./ProfileEditTabSection.vue?vue&type=template&id=5892c445&scoped=true&"
import script from "./ProfileEditTabSection.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabSection.vue?vue&type=style&index=0&id=5892c445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892c445",
  null
  
)

export default component.exports